<template>

	<div id="app">
		<mainCarousel></mainCarousel><br><br>
        <div class="imgbox"> <br> <div id="head-thai"> <font color='red'>&lt;New&gt;</font> : <b>ผลการประกวดตราสัญลักษณ์โครงการ ชนะเลิศเป็นผลงานของ นายบำรุง อิศรกุล</b></div> <img src="../../assets/news/logo_contest_win.jpg" width="50%" height="50%" alt="SMART CITY INFRALAB"></div>
        <br><hr><br>
        <div id="head-thai"> <b>รับสมัครประกวดตราสัญลักษณ์ โครงการวิจัย Smart City Infralab</b> <a href="/news/logo-contest"> ดูรายละเอียด (คลิก)</a><!--<a href="https://bit.ly/2YqZxfy" target="_blank"> สมัครเข้าร่วมได้ที่ https://bit.ly/2YqZxfy (คลิก)</a>--></div>
        <div id="head-thai"> (โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา)</div>
        <v-btn x-large color="primary" to="/news/logo-contest">ดูรายละเอียด(คลิก)</v-btn> 
        <br><a href="./news/logo-contest"><img id="full-image"  src="../../assets/news/logo_contest_brochure.jpg" width="50%" height="50%"></a>
        <br><v-btn x-large color="primary" to="/news/logo-contest">ดูรายละเอียด(คลิก)</v-btn> <br>
        <br><hr><br>
	</div>


	
</template>

<script>
import mainCarousel from '../carousel/main.vue'
  export default {
    components: {
		mainCarousel
	},
	metaInfo: {
        title: 'ประชาสัมพันธ์',
    },
  };
</script>

<style>
#full-image {
  margin-left: auto;
  margin-right: auto;
  display: block;
	object-fit: fill;
	width: 50%;
}
#head-thai {
  font-size:18pt;
  color: #043a20;
  text-align: left;
  padding-left: 50px;
}
</style>